import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import ConditionalBaseBox from "../layout/ConditionalBaseBox";
import { ReportFooter } from "../layout/ReportFooter";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(BoxTypes.OrderFrequencyFilter, data);
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <ConditionalBaseBox
      id={id}
      valid={BoxValidations.validate(BoxTypes.OrderFilter, data)}
      selected={selected}
      title={BoxTitles.OrderFilter}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {subline()}
    </ConditionalBaseBox>
  );
});
